<template>
  <div class="container">
    <h2>Hottest Giftcards</h2>
    <p><small>select the hottest giftcards you want to show up on the client app</small></p>
    <v-dialog v-model="dialog" max-width="500px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">
          Add Gift Card
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          Add Gift Card
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select @change="test" v-model="selectedStore" :items="stores" label="Store" item-value="id"
                  item-text="name"></v-select>
              </v-col>
              <v-col cols="12">
                <v-select @change="country" v-model="selectedCountry" :items="countries" label="Country" item-value="id"
                  item-text="name"></v-select>
              </v-col>
              <v-col cols="12">
                <v-select v-model="selectedGiftCard" :items="selectedGiftcards" label="Gift Card" item-text="name"
                  item-value="id"></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addGiftCard">Add</v-btn>
          <v-btn color="default" @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <br><br>
    <v-data-table :headers="headers" :items="giftCards" hide-default-footer>
      <template v-slot:item.logo="{ item }">
        <v-img :src="item.logo" style="width: 40px; height: 40px; border-radius: 50%"></v-img>
      </template>
      <template v-slot:item.action="{ item }">

        <v-btn icon color="error" @click="deleteGiftCard(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import { PromoService, StoresService } from "@/services";
import app from '@/main'


export default {
  name: 'GiftCardTable',
  data() {
    return {
      dialog: false,
      countries: [],
      stores: [],
      selectedCountry: null,
      selectedStore: null,
      selectedGiftCard: null,
      selectedGiftcards: [],
      giftCards: [],
      headers: [
        { text: 'Name', value: 'store_name' },
        { text: 'Category', value: 'name' },
        { text: 'Country ', value: 'country' },
        { text: 'Rate', value: 'rate' },
        { text: 'Type', value: 'type' },
        { text: 'Min', value: 'min' },
        { text: 'Max', value: 'max' },
        { text: 'Card Min', value: 'card_min' },
        { text: 'Card Max $', value: 'card_max' },
        { text: 'Logo', value: 'logo' },
        { text: 'Actions', value: 'action', sortable: false },
      ],
    }
  },
  async mounted() {
    await this.loadHottest();
    await this.loadStores();
  },
  methods: {
    close() {
      this.dialog = false;
      this.selectedCountry = null;
      this.selectedStore = null;
      this.selectedGiftCard = null;
      this.selectedGiftcards = [];
      this.countries = [];
    },
    async loadHottest() {
      try {
        const data = await PromoService.getAllHottest();
        console.log(data);
        this.giftCards = data;
      } catch (error) {
        console.log(error);
      }
    },
    country() {
      this.countries.forEach((store, i) => {
        if (store.id == this.selectedCountry) {

          console.log('found here', this.countries[i].giftcards);
          this.selectedGiftcards = this.countries[i].giftcards.map(gc => ({
            id: gc.id,
            name: `${gc.name} (${gc.type} - $ ${gc.cardMin} -$ ${gc.cardMax})`,
            type: gc.type,
            card_min: gc.card_min,
            card_max: gc.card_max
          }));
          return;
        }
      })
    },

    groupByCountry(items) {
     try {
      console.log('entered grouped by countries', items.length)
      let countries = [];
      items.forEach((item, i) => {
        let doesCountryExist = false;
        console.log('running the ' , i +1 , 'times(s)');
        if (countries.length == 0) {
          let country = {};
          country = item.country;
          country.giftcards = [];
          let giftcard = {
            id: item.id,
            name: item.name,
            rate: item.rate,
            type: item.type,
            min: item.min,
            max: item.max,
            cardMin: item.cardMin,
            cardMax: item.cardMax
          };
          country.giftcards.push(giftcard);
          countries.push(country);
        }
        else {
          let giftcard = {
            id: item.id,
            name: item.name,
            rate: item.rate,
            type: item.type,
            min: item.min,
            max: item.max,
            cardMin: item.cardMin,
            cardMax: item.cardMax
          };
          let country = item.country;
          country.giftcards =[];
          console.log(country.id);
          countries.forEach((coun, i) => {

            if (coun.id == country.id) {
              doesCountryExist = true;
             // countries[i].giftCards
              countries[i].giftcards.push(giftcard);
             
            }
            // else{
            //   country.giftcards.push(giftcard);
            // countries.push(country);
            // }
           
          });
          if(!doesCountryExist){
            country.giftcards.push(giftcard);
             countries.push(country);
             console.log('country does not exist');
          }

        }
        console.log(countries);
      });
      console.log('countries', countries);
      this.countries = countries;
     } catch (error) {
      console.log(error)
     }
    },


    async test() {
      app.$store.dispatch('toast', {
        message: ' loading store country...',
        variant: 'info'
      })
      const resp = await StoresService.loadGiftcards({ store: this.selectedStore });
      console.log('the selected store:', resp);
      if (resp) app.$store.dispatch('toast', {
        message: ' Countries loaded successfully',
        variant: 'success'
      })
      this.groupByCountry(resp);
     
    },
    async loadStores() {
      try {
        const data = await StoresService.getStores();
        console.log('load stores here: ', data);
        this.stores = data;
      } catch (error) {
        console.log(error);
      }
    },

    addGiftCard() {
      // Construct the gift card object
      console.log('gift card id', this.selectedGiftCard);
      const giftCard = {
        store_id: this.selectedStore,
        giftcard_id: this.selectedGiftCard,
        
      };

      // Call the API to add the gift card
      PromoService.addHottest(giftCard)
        .then(() => {
          // Clear the selected store and gift card
          this.selectedStore = null;
          this.selectedGiftCard = null;
          this.dialog = false;
          this.selectedCountry = null;
          this.selectedStore = null;
          this.selectedGiftCard = null;
          this.selectedGiftcards = [];
          this.countries = [];

          // Reload the hottest gift cards
          this.loadHottest();

          // Close the dialog
          this.dialog = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    editGiftCard(giftCard) {
      // handle edit action here
      console.log('Editing gift card:', giftCard)
    },
    async deleteGiftCard(giftCard) {
      try {
        console.log(giftCard);
        // Call the API to delete the gift card
        if (confirm('do you want to remove this card from hottest list')) {
          await PromoService.deleteHottest(giftCard);

          // Remove the gift card from the list
          const index = this.giftCards.findIndex(gc => gc.id === giftCard.id);
          if (index !== -1) {
            this.giftCards.splice(index, 1);
          }
          app.$store.dispatch('toast', {
            message: ' giftcard deleted successfully',
            variant: 'success'
          })
          await this.loadHottest();
        }
      } catch (error) {
        console.error(error);
      }
    },

  },
}
</script>
